module.exports = __webpack_public_path__ + "img/icon_xsgl.6474510e.png";